import {
    fetchIO,
    IUser,
    IUserIO,
    IUserList,
    IUserListIO,
    IMapBaseLayerIO,
} from 'sdi/source';
import * as io from 'io-ts';

const BaseLayerCollectionIO = io.dictionary(
    io.string,
    IMapBaseLayerIO,
    'BaseLayerCollection'
);
type BaseLayerCollection = io.TypeOf<typeof BaseLayerCollectionIO>;

export const fetchUser = (url: string): Promise<IUser> => fetchIO(IUserIO, url);

export const fetchAllUsers = (url: string): Promise<IUserList> =>
    fetchIO(IUserListIO, url);

export const fetchBaseLayerAll = (url: string): Promise<BaseLayerCollection> =>
    fetchIO(BaseLayerCollectionIO, url);
